__webpack_require__.p = "/registration/";